module.exports = __webpack_public_path__ + "static/media/sunil-jain.5aba7814.png";